import React, { useEffect, useState } from "react";

const About = () => {
  const [marginLeft, setMarginLeft] = useState("-95px");

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth >= 1024) {
        setMarginLeft("-95px");
      } else {
        setMarginLeft("0px");
      }
    };

    handleResize();

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);
  return (
    <div className="px-8 lg:px-32 xl:px-52 mt-20">
      <p className="font-bold text-black text-3xl pt-6">About Us</p>
      <div className="container mx-auto px-2 py-8 text-justify">
      <div className="md:text-[17px] text-black">
      <div className="flex flex-col mx-auto text-black">
      <div>
        <p className="text-sm sm:text-base mb-4 text-justify">
        SmartSpend: Expense Manager - Simple, Intuitive and
        Feature-Rich App for Managing Your Expenditure and Budget
        </p>
        <p className="text-sm sm:text-base mb-4 text-justify">
        SmartSpend: Expense Manager is the #1 Financial Planning,
        Expense Tracking, and Reviewing App. SmartSpend is one of the
        highly efficient personal asset management app on Android. Are
        you finding it difficult to track your expenses? This app is the
        ultimate option for maintaining the complete statement of your
        financial records. These are also helpful for avoiding losing
        any data on the bills and tickets.
        </p>
        <p className="text-sm sm:text-base mb-4 text-justify">
        SmartSpend: Expense Manager is a reliable option for recording
        personal as well as business financial transactions. You have a
        better way to easily review your daily, weekly as well as
        monthly financial data by using a simple app.
        </p>
        <p className="text-sm sm:text-base mb-4 text-justify">
        <b>All-In-One Expense and Budget App:</b>
        <br />
        Are you looking to manage your expenses and budget wisely?
        SmartSpend: Expense Manager is an intuitive and simple
        feature-rich app allowing you to record every expense. These
        also allow you to make perfect planning with your budget for
        your life. Choosing the daily expense manager app is the best
        option for having everything at your fingertip with managing the
        budget, checkbook as well as expenditures. Installing the
        expense tracker app is quite an efficient option for easily
        tracking spending as well as budget planning. All the data is
        saved on the personal cloud account or phone. You have absolute
        control of your data.
        </p>
        <p className="text-sm sm:text-base mb-4 text-justify">
        <b>Why Use SmartSpend: Expense Manager?</b>
        <br />
        In our busy schedule, it is quite important to keep a financial
        record of our daily spending. SmartSpend: Expense Manager is the
        perfect app for providing all your requirements.
        </p>
        <p className="text-sm sm:text-base mb-4 text-justify">
        Below are some of the reasons for using the daily expense
        manager:
        </p>
        <ul className="list-disc pl-6 text-sm sm:text-base mb-4 text-justify">
        <li>
          <b>Making Intelligent Financial Decisions:</b>
          <p className="text-justify">
            Better planning in life automatically increases savings. It
            is quite important to refrain from unnecessary spending by
            recording finances. Making careful decisions for financial
            life is quite helpful with a monthly expense planner.
          </p>
        </li>
        <li>
          <b>Month Wise Comparison:</b>
          <p className="text-justify">
            SmartSpend: Expense Manager lets you make monthly
            comparisons of spending, earnings, and expenses. Every
            financial data will be well organized to the extent. The
            budget planner is helpful for generating spending reports
            and managing your assets.
          </p>
        </li>
        <li>
          <b>Access Anywhere and Anytime:</b>
          <p className="text-justify">
            Installing the SmartSpend: Expense Manager App lets you
            access the cloud-based database anytime. Your data will be
            stored in the Cloud to get quick access to expense reports
            from anywhere across the world. You will require an internet
            connection to access tasks like the expense submission.
          </p>
        </li>
        <li>
          <b>No More Data Loss:</b>
          <p className="text-justify">
            SmartSpend allows you to easily scan receipts in real time.
            It will be a suitable option for avoiding data loss of any
            kind. Receipt and bill data can be easily extracted, even
            behind the scenes. All the data of financial expenses and
            budget are recorded safely and backed up on the Cloud.
          </p>
        </li>
        <li>
          <b>360-Degree Expense Summary:</b>
          <p>
            Installing the Expense Manager App is helpful for getting
            360-degree expense summaries with intuitive graphs of
            spending. The monthly expense tracker helps to sharpen the
            finances.
          </p>
        </li>
        <li>
          <b>Build Daily and Monthly Budgets:</b>
          <p className="text-justify">
            When you are aware of how much you are spending, then you
            can maintain an appropriate budget. Making monthly financial
            planning is easier by installing the daily expense manager.
            The app lets you build an accurate monthly budget for making
            pre-planned expenditures.
          </p>
        </li>
      </ul>
    
      <p className="text-sm sm:text-base mb-4 text-justify">
        <b>Features Of SmartSpend: Expense Manager App:</b>
        <br />
        SmartSpend: Expense Manager uses advanced technology to
        automatically categorize and provide you with a 360-degree view
        of income and expenses. The expense manager user guide gives you
        a complete detailed report on the transactions of money and
        helps to easily plan the budget accordingly. SmartSpend: Expense
        Manager app is a brilliant step for your futuristic approach to
        financial planning and strategy.
      </p>
   
      <ul className="list-disc pl-6 text-sm sm:text-base mb-4 text-justify">
        <li>
          <b>Daily Expense Tracker:</b>
          <p className="text-justify">
            SmartSpend: Expense Manager App lets you manage the expenses
            for consolidating the outgoing and incoming transactions.
          </p>
        </li>
        <li>
          <b>Track The Finances:</b>
          <p className="text-justify">
            Track the Finances feature is added in SmartSpend: Expense
            Manager, which allows you to get a customized report on
            spending and expenses.
          </p>
        </li>
        <li>
          <b>Money Saving Track Feature:</b>
          <p className="text-justify">
            Grow your wealth by simply keeping monthly financial
            planning using the daily expense manager. The tracker
            calculates the expenses along with your savings.
          </p>
        </li>
        <li>
          <b>Expenditure Summary:</b>
          <p className="text-justify">
            The SmartSpend: Expense Manager app is a perfect option for
            getting an accurate daily, weekly, and monthly summary of
            the budget. It lets you easily achieve your financial goal
            for your future.
          </p>
        </li>
      </ul>
      </div>

    </div>
        </div>
      </div>
    </div>
  );
};

export default About;
